import React from "react";
import Header from "../Common/Header";
import Footer from "../Common/Footer";
import Banner from "../Elements/Banner";
import AboutCompany from "../Elements/AboutCompany";
import Team from "../Elements/Team";
import { Helmet } from "react-helmet";

var bnrimg = require("./../../images/banner/abtus-03-07.png");

class Management extends React.Component {
  render() {
    const mobileView = window.innerWidth <= 768;
    const bannerStyle = {
      backgroundImage: `url(${bnrimg})`,
      backgroundSize: "cover",
      backgroundPosition: mobileView ? "19% " : "center center",
      backgroundRepeat: "no-repeat",
    };
    return (
      <>
      <Helmet>
        <title>Cheran Machines Management Team | Textile Machinery Leaders</title>
      
        <meta
          name="description"
          content="Meet the Cheran Machines management team, leaders in textile machinery in India, driving innovation and excellence in garment printing solutions."
        />
      
        <meta
          name="keywords"
          content="Cheran Machines management team, textile machinery leadership India"
        />
        <link rel="canonical" href="https://www.cheranmachines.com/Management" />
      </Helmet>
        <Header />
        <div className="page-content">
          <div>
            <Banner
              className="management-ban"
              title="Meet the Expert Team Behind Cheran Machines"
              pagename="About Us"
              bgimage={bnrimg}
              bannerstyle={bannerStyle}
            />
          </div>
          <Team />
          <AboutCompany />

          {/* <p>Creating quality urban lifestyles, building stronger communitie</p> */}
        </div>

        <Footer />
      </>
    );
  }
}

export default Management;
